import React from 'react';
import TerrainTile from '@components/game/containers/TerrainTile';
import useMapStore from '@store/useMapStore';
import { EMPTY_ARRAY } from "@utils/constants";

// Simple deep equality check for tiles array
const isEqual = (a, b) => {
  if (a === b) return true;
  if (!a || !b || a.length !== b.length) return false;
  return a.every((tile, i) =>
    tile.x === b[i].x &&
    tile.y === b[i].y &&
    tile.terrain === b[i].terrain
  );
};

// Este componente solo se preocupa de dibujar el terreno.
const TerrainLayer = ({ tiles, mapWidth, tileSize }) => {
  const highlightTiles = useMapStore.getState().visual.highlightTiles || EMPTY_ARRAY;

  if (!tiles || tiles.length === 0) {
    console.warn("[TerrainLayer] No terrain tiles available.");
    return null;
  }
  if (!mapWidth) {
    console.warn("[TerrainLayer] No map width provided, using default of 20 tiles.");
    return null;
  }
  if(!highlightTiles || highlightTiles.length === 0) {
    //console.warn("[TerrainLayer] No highlight tiles available.");
  } else{
    //console.info("[TerrainLayer] Highlighting tiles:", highlightTiles);
  }

  return (
    <div
      className="map-grid"
      style={{
        "--map-width": mapWidth,
        "--tile-size": `${tileSize}px`
      }}
    >
      {tiles.map(({ x, y, terrain }) => {
        const isHighlighted = highlightTiles.some(t => t.x === x && t.y === y);
        return (
          <TerrainTile
            key={`${x}-${y}`}
            x={x}
            y={y}
            terrain={terrain}
            isHighlighted={isHighlighted}
          />
        );
      })}
    </div>
  );
};

// React.memo junto con isEqual previene re-renderizados innecesarios.
const MemoizedTerrainLayer = React.memo(TerrainLayer, (prevProps, nextProps) => {
  // Re-render if tiles OR tileSize changes
  return isEqual(prevProps.tiles, nextProps.tiles) && prevProps.tileSize === nextProps.tileSize;
});

export default MemoizedTerrainLayer;
